import { render, staticRenderFns } from "./MyArticles.vue?vue&type=template&id=7f6e83ea&scoped=true"
import script from "./MyArticles.vue?vue&type=script&lang=js"
export * from "./MyArticles.vue?vue&type=script&lang=js"
import style0 from "./MyArticles.vue?vue&type=style&index=0&id=7f6e83ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6e83ea",
  null
  
)

export default component.exports